import React, { useEffect, useRef, useState } from 'react'
import { Navigate } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import logoImage from '../../Assest/logo.png';
import '../Signin/Login.css'
import { Toast } from 'primereact/toast';
import { Api } from '../../services/api';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
const ResetPassword = () => {

  // const API_BASE_URL = 'http://161.97.86.43/demo/lidahome/api/';
  const toast = useRef(null);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [userId, setUserId] = useState(true);
  // Use URLSearchParams to parse the query parameters
  const queryParams = new URLSearchParams(location.search);

  // Get the value of the 'requestId' parameter
  const requestId = queryParams.get('requestId');
  useEffect(() => {

    getUser();



  }, []);

  const getUser = () => {
    console.log('requestId', requestId)
    const headers = {

      'Content-Type': 'application/json', // Specify JSON content
    };
    axios.get(Api.API_BASE_URL + 'get-request-details/' + requestId, { headers })
      .then((response) => {

        if (response.data.error != "") {
          toast.current.show({ severity: 'error', detail: response.data.error });
          setTimeout(function () {
            window.location = "/";
          }, 500);
        } else {
          setUserId(response.data.result.user_id);
          setIsLoading(false);
        }

      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
        setIsLoading(false);
      });


  }

  const [formData, setFormData] = useState({


    password: '',
    confPassword: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    console.log('Form submitted');
    const headers = {

      'Content-Type': 'application/json', // Specify JSON content
    };

    var url = Api.API_BASE_URL + 'reset-password';
    if (formData.password === formData.confPassword) {
      fetch(url, {
        method: "POST",
        headers: headers,

        body: JSON.stringify({ user_id: userId, password: formData.password }),
      })
        .then((response) => response.json())
        .then((Josn) => {



          if (Josn.error !== '') {
            console.log(Josn.error);
            toast.current.show({ severity: 'error', detail: Josn.error });


          } else {
            toast.current.show({ severity: 'success', detail: Josn.result });
            setTimeout(function () {
              window.location = "/";
            }, 500);

          }

        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      toast.current.show({ severity: 'error', detail: 'Password and Confirm Password does not match' });
    }








  };


  return (
    <>
      <Toast ref={toast} />
      <div className="container">

        <div className="section1"></div>
        <div className="section2"></div>
        <div className="main">
          <div className='mat-card'>
            <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
              {/* <img src={logoImage} alt="logo" className='img-class' /> */}
              <strong className='text-4xl'>Builder Playbook</strong>
            </div>
            <form onSubmit={handleSubmit} >

              <div >
                {/* <input className='input-log' type="hidden" placeholder="user_id" name="user_id" value={formData.password} onChange={handleInputChange} required/>    */}
                <input className='input-log' type="password" placeholder="Password" name="password" value={formData.password} onChange={handleInputChange} required />
              </div>
              <div >
                <input className='input-log' type="password" placeholder="Confirm Password" name="confPassword" value={formData.confPassword} onChange={handleInputChange} required />
              </div>
              <button className='button-login' type="submit" >
                Submit
              </button>
            </form>

          </div>
        </div>
      </div></>
  );
};


export default ResetPassword;





